import React, { useState, useContext, useEffect, useRef } from "react"
import axios from "axios"
import { Button, Stack, TextField, Switch, Box, LinearProgress, Autocomplete, IconButton, InputAdornment, Chip } from "@mui/material"
import { List, ListItem, ListItemText, ListItemButton, ListItemAvatar, Avatar } from "@mui/material"
import { Delete as DeleteIcon, Add as AddIcon, Scale as ScaleIcon } from "@mui/icons-material"
import { cartContext } from "./cartContext"
import { SmartScaleChip } from "./SmartScaleChip"
import { getProductListOverview, getProductBySku, getSelfCheckoutProducts, updateProductAmount } from "../products/products"
import FormControl from "@mui/material/FormControl"
import FavoriteIcon from "@mui/icons-material/Favorite"
const __ = wp.i18n.__

function AddProductBySku({ setShowCart, setAdding, scanResult, POSMode }) {
  const currencySymbol = frontendLocalizer?.currencySymbol || frontendLocalizer?.currency || "CHF"

  const { cart, setCart } = useContext(cartContext)
  const [products, setProducts] = useState(null)
  const [productsLoading, setProductsLoading] = useState(true)
  const [amount, setAmount] = useState(1)
  const [sku, setSku] = useState("")
  const [product, setProduct] = useState(null)
  const [freePosition, setFreePosition] = useState("")
  const [freePositionPrice, setFreePositionPrice] = useState(0)
  const [freeEntry, setFreeEntry] = useState(false)
  const [userWeightValue, setUserWeightValue] = useState(0)
  const [userFavorit, setUserFavorit] = useState(false)
  const [userTaraValue, setUserTaraValue] = useState(0)
  const [userTaraError, setUserTaraError] = useState("")
  const [userVerpackungen, setUserVerpackungen] = useState([])
  const [userVerpackungName, setUserVerpackungName] = useState("")
  const [userVerpackungFormVisible, showUserVerpackungForm] = useState(false)
  const [userProduktFavoriten, setUserProduktFavoriten] = useState([])

  useEffect(() => {
    updateProducts()
    updateUserVerpackungen()
    updateUserProduktFavoriten()
  }, [])

  useEffect(() => {
    setUserFavorit(product ? isUserFavorit(product.sku) : false)
  }, [product])

  function addUserVerpackung() {
    axios
      .post(
        `${frontendLocalizer.apiUrl}/pingvin_checkout/v1/addUserVerpackung`,
        {
          name: userVerpackungName,
          gewicht: userTaraValue
        },
        { headers: { "X-WP-Nonce": frontendLocalizer.nonce } }
      )
      .then(function (response) {
        showUserVerpackungForm(false)
        setUserVerpackungName(null)

        if (response.data.userVerpackungen) {
          setUserVerpackungen(response.data.userVerpackungen)
        }
      })
      .catch(error => console.log(error))
  }

  function removeUserVerpackung(name) {
    axios
      .post(
        `${frontendLocalizer.apiUrl}/pingvin_checkout/v1/removeUserVerpackung`,
        {
          name: name
        },
        { headers: { "X-WP-Nonce": frontendLocalizer.nonce } }
      )
      .then(function (response) {
        if (response.data.userVerpackungen) {
          setUserVerpackungen(response.data.userVerpackungen)
        }
      })
      .catch(error => console.log(error))
  }

  function updateProducts() {
    let reArrangeProductData = []
    getSelfCheckoutProducts()
      .then(function (scProds) {
        getProductListOverview()
          .then(function (response) {
            if (response.products) {
              const prod = response.products
              Object.keys(prod).forEach(function (key) {
                let product = prod[key]

                if (scProds.includes(product.id)) {
                  product.label = product.name + " (" + product.sku + ") — " + currencySymbol + " " + parseFloat(product.price).toFixed(2) + (product.weight ? " / " + product.weight + " " + product.weight_unit : "")

                  reArrangeProductData.push(product)

                  if (product.sku == scanResult) {
                    setProduct(product)
                    setSku(product.sku)
                  }
                }
              })
              setProducts(reArrangeProductData)
              setProductsLoading(false)
            }
          })
          .catch(error => console.log(error))
      })
      .catch(error => console.log(error))
  }

  function updateUserVerpackungen() {
    axios
      .get(`${frontendLocalizer.apiUrl}/pingvin_checkout/v1/getUserVerpackungen`, {
        headers: { "X-WP-Nonce": frontendLocalizer.nonce }
      })
      .then(function (response) {
        if (response.data.userVerpackungen) {
          setUserVerpackungen(response.data.userVerpackungen)
        }
      })
      .catch(error => console.log(error))
  }

  function updateUserProduktFavoriten() {
    axios
      .get(`${frontendLocalizer.apiUrl}/pingvin_checkout/v1/getUserProduktFavoriten`, {
        headers: { "X-WP-Nonce": frontendLocalizer.nonce }
      })
      .then(function (response) {
        if (response.data.userProduktFavoriten) {
          setUserProduktFavoriten(response.data.userProduktFavoriten)
        }
      })
      .catch(error => console.log(error))
  }

  function addProduct() {
    getProductBySku(sku)
      .then(product => {
        if (!product) {
          console.error("Product not found for SKU:", sku)
          setAdding(false)
          return
        }

        const cartItem = JSON.parse(JSON.stringify(product))

        cartItem.order_type = "self_checkout"
        cartItem.amount = amount

        updateProductAmount(cartItem, userWeightValue, userTaraValue)

        const newCart = [...cart, cartItem]
        setCart(newCart)

        localStorage.setItem("fc_selfcheckout_cart", JSON.stringify(newCart))

        setAdding(false)
        setShowCart(true)
      })
      .catch(error => {
        console.error("Error adding product to cart:", error)
        setAdding(false)
        // Don't show dialog anymore, user can retry or scan again
      })
  }

  function isUserFavorit(id) {
    return userProduktFavoriten ? userProduktFavoriten.indexOf(id) >= 0 : false
  }

  function addFreeProduct() {
    const newCart = [
      ...cart,
      {
        id: cart.length,
        order_type: "self_checkout",
        amount: 1,
        name: freePosition,
        price: parseFloat(freePositionPrice),
        product_id: 0,
        sku: "fcplugin_pos_product",
        unit: ""
      }
    ]
    setCart(newCart)
    setShowCart(true)
    setAdding(false)
    setFreeEntry(false)
    setFreePosition("")
    setFreePositionPrice(0)
  }

  function resetProduct() {
    setProduct(null)
  }

  function toggleUserFavorit() {
    axios
      .post(
        `${frontendLocalizer.apiUrl}/pingvin_checkout/v1/toggleUserProduktFavorit`,
        {
          sku: product.sku
        },
        {
          headers: { "X-WP-Nonce": frontendLocalizer.nonce }
        }
      )
      .then(function (response) {
        setUserFavorit(response.data.userFavorit)
        setUserProduktFavoriten(response.data.userProduktFavoriten)
      })
      .catch(error => console.log(error))
  }

  useEffect(() => {
    !POSMode && setFreeEntry(false)
  }, [POSMode])

  return (
    <>
      {!productsLoading ? (
        <>
          <Stack spacing={3} sx={{ width: "100%" }}>
            <strong>{__("Add product", "pingvin_checkout")}</strong>

            {POSMode && (
              <Box sx={{ marginRight: 2 }}>
                {__("Free entry?", "pingvin_checkout")} <Switch checked={freeEntry} onChange={event => setFreeEntry(event.target.checked)} inputProps={{ "aria-label": "freeEntry" }} color={"POSModeColor"} />
              </Box>
            )}

            {freeEntry ? (
              <>
                <TextField size="normal" id="custom-name" label={__("Custom name", "pingvin_checkout")} name="custom-name" variant="outlined" value={freePosition} onChange={e => setFreePosition(e.target.value)} autoFocus color={POSMode ? "POSModeColor" : "primary"} />
                <TextField size="normal" id="price" label={__("Price", "pingvin_checkout")} name="price" variant="outlined" value={freePositionPrice} onChange={e => setFreePositionPrice(e.target.value)} autoFocus color={POSMode ? "POSModeColor" : "primary"} />
                <Button onClick={addFreeProduct} variant="contained" size="large" color={POSMode ? "POSModeColor" : "primary"}>
                  {__("Add to cart", "pingvin_checkout")}
                </Button>
              </>
            ) : (
              <>
                {userVerpackungFormVisible ? (
                  <>
                    <FormControl>
                      <TextField id="userTaraValue" value={userTaraValue} onChange={e => setUserTaraValue(e.target.value)} variant="outlined" type="number" label={__("Tare weight", "pingvin_checkout") + " ( kg )"} InputProps={{ endAdornment: <SmartScaleChip onApply={setUserTaraValue} /> }} />
                      {userTaraError ? <span> {__(userTaraError, "pingvin_checkout")}</span> : <span />}
                    </FormControl>
                    <FormControl>
                      <TextField id="userVerpackungName" value={userVerpackungName} onChange={e => setUserVerpackungName(e.target.value)} variant="outlined" type="text" label={__("Packaging name", "pingvin_checkout")} />
                    </FormControl>
                    <Button onClick={addUserVerpackung} variant="contained" size="large" color={POSMode ? "POSModeColor" : "primary"}>
                      {__("Save packaging", "pingvin_checkout")}
                    </Button>
                  </>
                ) : (
                  <Stack spacing={3} sx={{ width: "100%", paddingTop: "10px" }}>
                    {products && (
                      <Autocomplete
                        sx={{ width: "100%" }}
                        value={product}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onChange={(event, newValue) => {
                          setProduct(newValue)
                          setSku(newValue ? newValue.sku : null)
                        }}
                        id="product"
                        options={products}
                        disablePortal
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={__("Product", "pingvin_checkout")}
                            className="autocompleteField"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: product ? (
                                <>
                                  <InputAdornment position="end">
                                    <IconButton onClick={toggleUserFavorit}>
                                      <FavoriteIcon sx={{ color: userFavorit ? "red" : "black" }} />
                                    </IconButton>
                                  </InputAdornment>
                                  {params.InputProps.endAdornment}
                                </>
                              ) : null
                            }}
                          />
                        )}
                      />
                    )}

                    {product ? (
                      <>
                        {product.is_weighed ? (
                          <>
                            <FormControl>
                              <TextField id="userWeightValue" value={userWeightValue} onChange={e => setUserWeightValue(e.target.value)} variant="outlined" type="number" label={__("Total weight", "pingvin_checkout") + " ( " + product.weight_unit + " )"} InputProps={{ endAdornment: <SmartScaleChip onApply={setUserWeightValue} /> }} />
                            </FormControl>
                            <FormControl>
                              <TextField id="userTaraValue" value={userTaraValue} onChange={e => setUserTaraValue(e.target.value)} variant="outlined" type="number" label={__("Tare weight", "pingvin_checkout") + " ( kg )"} InputProps={{ endAdornment: <SmartScaleChip onApply={setUserTaraValue} /> }} />
                              {userTaraError ? <span> {__(userTaraError, "pingvin_checkout")}</span> : <span />}
                            </FormControl>
                            <Button onClick={addProduct} variant="contained" size="large" color={POSMode ? "POSModeColor" : "primary"}>
                              {__("Add to cart", "pingvin_checkout")}
                            </Button>
                            <List dense={true}>
                              <ListItem
                                disableGutters
                                secondaryAction={
                                  <IconButton
                                    onClick={() => {
                                      showUserVerpackungForm(true)
                                    }}
                                  >
                                    <AddIcon />
                                  </IconButton>
                                }
                              >
                                <ListItemText>
                                  <strong>{__(userVerpackungen.length > 0 ? "Saved packaging" : "Save packaging", "pingvin_checkout")}</strong>
                                </ListItemText>
                              </ListItem>
                              {userVerpackungen.map(verpackung => (
                                <ListItem
                                  disableGutters
                                  secondaryAction={
                                    <IconButton
                                      onClick={() => {
                                        removeUserVerpackung(verpackung.name)
                                      }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  }
                                >
                                  <ListItemButton
                                    onClick={() => {
                                      setUserTaraValue(verpackung.gewicht)
                                    }}
                                  >
                                    <ListItemText primary={verpackung.name + " ( " + verpackung.gewicht + " kg)"} />
                                  </ListItemButton>
                                </ListItem>
                              ))}
                            </List>
                          </>
                        ) : (
                          <>
                            <FormControl>
                              <TextField id="amount" value={amount} onChange={e => setAmount(e.target.value)} variant="outlined" type="number" label={__("Quantity", "pingvin_checkout")} />
                            </FormControl>
                            <Button onClick={addProduct} variant="contained" size="large" color={POSMode ? "POSModeColor" : "primary"}>
                              {__("Add to cart", "pingvin_checkout")}
                            </Button>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <List>
                          <ListItem disableGutters>
                            <ListItemAvatar>
                              <Avatar>
                                <FavoriteIcon />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText>
                              <strong>{__("Your favorites", "pingvin_checkout")}</strong>
                            </ListItemText>
                          </ListItem>
                          {products
                            .filter(function (product) {
                              const productExists = cart.some(cartItem => {
                                return product.sku === cartItem.sku
                              })

                              return !productExists && isUserFavorit(product.sku)
                            })
                            .map(product => (
                              <ListItem disableGutters key={product.sku}>
                                <ListItemButton
                                  onClick={() => {
                                    setProduct(product)
                                    setSku(product ? product.sku : null)
                                  }}
                                >
                                  <ListItemAvatar>
                                    <Avatar>{product.img ? <img src={product.img} width={"50px"} height={"50px"} /> : <span />}</Avatar>
                                  </ListItemAvatar>
                                  <ListItemText primary={product.label} />
                                </ListItemButton>
                              </ListItem>
                            ))}
                        </List>
                      </>
                    )}
                  </Stack>
                )}
              </>
            )}
          </Stack>
        </>
      ) : (
        <Box sx={{ width: "98%" }}>
          <LinearProgress />
        </Box>
      )}
    </>
  )
}

export default AddProductBySku
